module.exports = "pegasus/assets/twitter-bird-tiny.png";